var exports = {
  "kL": "x127c5a35--784a81--container",
  "Sl": "x127c5a35--784a81--image",
  "BI": "x127c5a35--784a81--favorite",
  "Qs": "x127c5a35--784a81--content",
  "gO": "x127c5a35--784a81--ellipsis",
  "Mg": "x127c5a35--784a81--price-discount",
  "mr": "x127c5a35--784a81--old-price",
};

module.exports = exports;
